// oxlint-disable-next-line no-restricted-imports -- Legacy table migration/demo — do not copy into new code.
import { GridTableRow } from "@design-system/Tables/GridTable/GridTable";
import { DocumentName } from "../documents/DocumentName";
import { ImporterDocumentStatus } from "./ImporterDocumentStatus";
import styles from "./ImporterPage.module.scss";
import { ImporterDocumentRow } from "./types";

interface Props {
    rowNumber: number;
    documentRow: ImporterDocumentRow;
    file: File;
}

export const ImporterTableUploadRow: React.FC<Props> = ({
    rowNumber,
    documentRow,
    file,
}) => (
    <GridTableRow
        columnBorders
        className={styles.row}
        onClick={(e) => e.stopPropagation()}
        clickable={false}
    >
        <GridTableRow columnBorders className={styles.stickyLeft}>
            <div className={styles.rowNumber}>{rowNumber}</div>
            <div>
                <DocumentName fileName={file.name} />
            </div>
        </GridTableRow>
        <ImporterDocumentStatus documentRow={documentRow} />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <GridTableRow columnBorders className={styles.stickyRight}>
            <div />
        </GridTableRow>
    </GridTableRow>
);
